<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="extraData.userContext.currentUser.ground.name"
          :hint="'Área: ' + numberToDecimal(extraData.userContext.currentUser.ground.area) + ' ha, Área disponível: ' + numberToDecimal(extraData.userContext.currentUser.ground.availableArea) + ' ha'"
          persistent-hint
          label="Área Selecionada"
          disabled
        />
      </v-col>

      <v-col cols="12" sm="8">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="4">
        <v-switch 
          v-model="entry.enabled" 
          inset 
          :label="entry.enabled ? 'Ativo' : 'Inativo'"
          :disabled="readOnly">
        </v-switch>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('area')"
          :inputData.sync="entry.area"
          mask-type="currency"
          label="Área Total"
          suffix="ha"
          autocomplete="off"
          :disabled="readOnly"
        />
        <!-- suffix="m²" -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('usefulArea')"
          :inputData.sync="entry.usefulArea"
          mask-type="currency"
          label="Área Útil"
          suffix="ha"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          outlined
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
